<template>
  <div v-if="visible">
    <div class="overlay"></div>
    <div class="popup guide">
      <img src="@/assets/images/icons/caution_red_ico.svg" />
      <div class="popup-content" v-if="!noRegistered">
        <p>{{ $t('refPopupMsg.popup1', {date:day}) }}</p>
        <p>{{ $t('refPopupMsg.popup2') }}</p>
        <p>{{ $t('refPopupMsg.popup3') }}</p>
      </div>

      <div class="popup-content" v-else-if="noRegistered">
        <p>{{ $t('refPopupMsg.popup4') }}</p>
        <p>{{ $t('refPopupMsg.popup5') }}</p>
      </div>

      <div class="popup__btns">
        <button v-if="buttonEnabled" @click="goRef">
          {{ $t("refPopup.refLink") }}
        </button>

        <button v-if="!buttonEnabled" :disabled="!buttonEnabled" @click="closePopup">
          <p class="countdown">{{ countdown }}</p>
        </button>

        <button v-if="buttonEnabled && !noRegistered" :disabled="!buttonEnabled" @click="closePopup" class="close__btn">
          <p>{{ $t("chart1.close") }}</p>
        </button>

        
      </div>
    </div>
  </div>
  </template>
  
<script setup>
import { useStore } from "vuex";
import { ref, computed, watch } from "vue";

const day = ref(0);
const countdown = ref(3)
const store = useStore();
const visible = ref(false)
let noRegistered = ref(false); // 레퍼럴 등록여부 확인 
const buttonEnabled = ref(false)
const homeUrl = process.env.VUE_APP_HOME_URL

let userInfo = computed(() => store.state.userInfo.risingUserInfo);
const guidePopupState = computed(() => store.state.usePopupList.isRefPopup);

// 레퍼럴 등록 안내 팝업 띄우는 함수
function showPopup() {
  visible.value = true
  buttonEnabled.value = false
  countdown.value = 3

  const interval = setInterval(() => {
    if (--countdown.value <= 0) {
      buttonEnabled.value = true
      clearInterval(interval)
    }
  }, 1000)
}

// 레퍼럴 미등록 안내 팝업 띄우는 함수
function showRegisterPopup() {
  visible.value = true
  buttonEnabled.value = true
}

// 닫기 함수
function closePopup() {
  visible.value = false
  store.dispatch("usePopupList/setRefPopup", false);
}

// 레퍼럴 등록 페이지로 이동함수
function goRef() {
  store.dispatch("usePopupList/setRefPopup", false);
  location.href = `${homeUrl}/payback/ex?menuName=ex_payback_payback`
}

watch(
  () => userInfo.value,
  (newVal) => {
    day.value = newVal?.ref_day ? newVal?.ref_day : 0;
    noRegistered.value = newVal?.ref_chart ? newVal?.ref_chart : false;

    if (newVal?.free_plan && newVal?.ref_day && !newVal?.ref_chart && guidePopupState.value) {
      showPopup()
    }
    else if (noRegistered.value) {
      showRegisterPopup()
    }
  },
  { immediate: true }
)

</script>
  
<style lang="scss" scoped>
@import "@/assets/scss/commons/modal/referral.scss";
</style>